import { IEvaluationContext } from "../IEvaluationContext";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { MatchKind } from "../../../../../../Common/ModelPath/PathMatcher";
import { wrapDecimalOperand } from "../../../../Helpers/AutocalcCommonFunctions";
import { KCExpressionRuntime, PlainModelValue } from "../KCExpressionRuntime";
import { arrayHasLength, isNotNullOrEmpty } from "../../../../../../Common/TypingUtils";
import { ModelEvent } from "../../EventManagement/ModelEvents/ModelEvent";

export class KCCountCalculation {
    public static execute(
        context: IEvaluationContext,
        targetPath: AbsoluteModelPath,
        dependencyPath: AbsoluteModelPath,
        isDependencyAggregation: boolean,
        defaultValue: string
    ): PlainModelValue {
        if (arrayHasLength(context.relatedEvents, 0)) {
            const expressionRuntime = new KCExpressionRuntime(context);
            return expressionRuntime.count(dependencyPath.toLegacyPath()) ?? defaultValue;
        }
        const currentValue = wrapDecimalOperand(context.get(targetPath));
        const nextValue = Iterator.from(context.relatedEvents)
            .filter(evt =>
                dependencyPath
                    .matchFor(evt.path)
                    .every(x => x.kind === MatchKind.MatchedPath || x.kind === MatchKind.MatchedMultiplicity)
            )
            .reduce((sum, curr: ModelEvent) => {
                const oldValue = isNotNullOrEmpty(curr.oldValue as string | undefined)
                    ? isDependencyAggregation
                        ? wrapDecimalOperand(curr.oldValue as string | undefined)
                        : 1
                    : 0;
                const value = isNotNullOrEmpty(curr.value as string | undefined)
                    ? isDependencyAggregation
                        ? wrapDecimalOperand(curr.value as string | undefined)
                        : 1
                    : 0;
                return sum.minus(oldValue).add(value);
            }, currentValue);
        return nextValue.toFixed();
    }
}
